import type { ChecklistCondition } from '@cmms/types'

export function evaluateCondition(
  condition: ChecklistCondition | null | undefined,
  answersMap: Record<string, { value_text?: string | null; value_number?: number | null }>
): boolean {
  if (!condition) return true
  const answer = answersMap[condition.item_id]
  if (!answer) return false

  const raw = answer.value_text ?? String(answer.value_number ?? '')
  const val = String(condition.value)

  switch (condition.operator) {
    case 'equals':     return raw.toLowerCase() === val.toLowerCase()
    case 'not_equals': return raw.toLowerCase() !== val.toLowerCase()
    case 'contains':   return raw.toLowerCase().includes(val.toLowerCase())
    case 'gte':        return Number(raw) >= Number(val)
    case 'lte':        return Number(raw) <= Number(val)
    default:           return true
  }
}
